import React, { useEffect } from 'react';

const HeyzineFlipbook = () => {
  useEffect(() => {
    // Load Heyzine script only once
    const script = document.createElement('script');
    script.src = 'https://cdnc.heyzine.com/release/addons.5.min.js';
    script.async = true;
    script.onload = () => {
      if (window.heyzinea?.addons) {
        window.heyzinea.addons.init();
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      {/* Heyzine CSS */}
      <link
        rel="stylesheet"
        href="https://cdnc.heyzine.com/release/heyzine.4.min.css"
      />

      <div
        style={{
          backgroundColor: 'whitesmoke',
          border: '1px solid lightgray',
          boxShadow: 'inset 0 -10px 10px -5px rgba(0, 0, 0, 0.2)',
          padding: '24px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div
          className="heyzine-flip"
          style={{
            maxWidth: '350px',
            width: '100%',
            aspectRatio: '2 / 3',
            borderRadius: '5px',
            overflow: 'hidden',
          }}
        >
          <div className="container">
            {/* Front */}
            <div className="front fp-w fp-fh fp-h">
              <img
                src="https://cdnc.heyzine.com/flip-book/cover/46d98463c9.jpg"
                className="img-front fp-thumb"
                alt="Catalog cover"
              />
            </div>

            {/* Back */}
            <div className="back fp-w fp-fh fp-h">
              <img
                src="https://cdnc.heyzine.com/flip-book/cover/46d98463c9.jpg"
                className="img-back fp-thumb"
                alt="Catalog back"
              />
              <div className="inner">
                <a
                  href="https://heyzine.com/flip-book/46d98463c9.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="heyzine-link fp-link"
                  data-heyzine-open="modal"
                >
                  ดู Catalog ฉบับล่าสุด
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeyzineFlipbook;
